import { jsx } from 'react/jsx-runtime';
import { uniqBy } from 'lodash-es';
import { useMemo } from 'react';
import { useWindowSize } from 'react-use';
import { emptyColumn } from '../../../constants/modelCompareData/data/products/emptyColumn.mjs';
import { useModelCompareTranslation } from '../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import '../../../contexts/MenuContext/index.mjs';
import { TABLE_COLUMN_WIDTH } from '../constants.mjs';
import { MOBILE_BREAKPOINT } from './CompareTable.styles.mjs';
import { CompareTableMarkup } from './CompareTableMarkup/CompareTableMarkup.mjs';
import './helpers/index.mjs';
import { getNumberOfColumns } from './helpers/getNumberOfColumns.mjs';
import { useMenu } from '../../../contexts/MenuContext/context.mjs';
import { filterProducts } from './helpers/filterProducts.mjs';
import { transformProductForCompare } from './helpers/transformProductForCompare.mjs';
import { createEmptyGridItems } from './helpers/createEmptyGridItems.mjs';
"use strict";
const MAX_PRODUCTS_WITHOUT_EMPTY_COLUMNS = 5;
const CompareTable = ({
  headerStickOffset,
  overlayTopOffset,
  showBuyButton,
  onLinkClick,
  linkToStoreTitleClick,
  additionalProductData,
  selectedProducts,
  setSelectedProducts,
  section,
  products,
  hasBeenObserved,
  selectedProductsLimit,
  setExternalSelectedProducts,
  isOverviewPage,
  isStaticTable
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  const {
    width: screenWidth
  } = useWindowSize();
  const {
    storeId
  } = useMenu();
  const mutatedProducts = useMemo(() => products.filter(product => filterProducts(product, selectedProducts)).map(product => transformProductForCompare({
    product,
    storeId,
    formatMessage,
    additionalProductData
  })), [additionalProductData, formatMessage, products, storeId, selectedProducts]);
  const productsToBeRenderedInTable = useMemo(() => uniqBy(mutatedProducts, "id"), [mutatedProducts]);
  const productOrder = useMemo(() => selectedProducts.map(product => product.productId), [selectedProducts]);
  const sortedProducts = useMemo(() =>
  // eslint-disable-next-line sonarjs/no-misleading-array-reverse
  productsToBeRenderedInTable.sort((a, b) => productOrder.indexOf(a.id) - productOrder.indexOf(b.id)), [productOrder, productsToBeRenderedInTable]);
  const numberOfColumns = useMemo(() => getNumberOfColumns({
    selectedProducts,
    selectedProductsLimit,
    products
  }), [selectedProducts, selectedProductsLimit, products]);
  const numberOfEmptyColumns = useMemo(() => isStaticTable || section.products.length === MAX_PRODUCTS_WITHOUT_EMPTY_COLUMNS ? 0 : numberOfColumns - productsToBeRenderedInTable.length, [numberOfColumns, productsToBeRenderedInTable.length, section.products.length, isStaticTable]);
  const emptyColumns = useMemo(() => createEmptyGridItems({
    emptyItem: emptyColumn,
    numberOfEmptyColumns,
    additionalProductData,
    storeId,
    isMobile: screenWidth < MOBILE_BREAKPOINT
  }), [numberOfEmptyColumns, additionalProductData, storeId, screenWidth]);
  const productsWithEmptyGridItems = useMemo(() => [...sortedProducts, ...emptyColumns], [sortedProducts, emptyColumns]);
  const properties = useMemo(() => section.properties.map(property => ({
    ...property,
    title: formatMessage(property.title),
    tooltip: property.tooltip && formatMessage(property.tooltip)
  })), [formatMessage, section.properties]);
  if (!section) {
    return null;
  }
  return /* @__PURE__ */jsx(CompareTableMarkup, {
    products: productsWithEmptyGridItems,
    properties,
    columnWidth: TABLE_COLUMN_WIDTH,
    propertyColumnWidth: section.propertyColumnWidth,
    headerStickOffset,
    overlayTopOffset,
    showBuyButton,
    onLinkClick,
    linkToStoreTitleClick,
    showBadges: section.showBadges,
    selectedProducts,
    setSelectedProducts,
    setExternalState: setExternalSelectedProducts,
    hasBeenObserved,
    selectedProductsLimit,
    currAvailableProducts: products,
    isOverviewPage,
    isStaticTable
  });
};
export { CompareTable };
//# sourceMappingURL=CompareTable.mjs.map
